import { useSiteContent, parseNavLinks } from "@/hooks/useSiteContent";
import { Menu, Phone } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { optimizedImage } from "@/lib/img";

export function Header() {
  const { content } = useSiteContent();
  const [open, setOpen] = useState(false);
  const links = parseNavLinks(content.nav_links);
  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/85 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between">
        <a href="#home" className="flex items-center gap-2">
          {content.logo_url ? (
            <img src={optimizedImage(content.logo_url, 96)} alt={content.shop_name} width={36} height={36} loading="eager" decoding="async" className="h-9 w-9 rounded-lg object-cover shadow-glow" />
          ) : (
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-primary text-primary-foreground font-black shadow-glow">G</div>
          )}
          <div className="leading-tight">
            <div className="text-sm font-extrabold">{content.shop_name}</div>
            <div className="text-[10px] font-medium uppercase tracking-wider text-accent">{content.brand_tagline}</div>
          </div>
        </a>
        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => <a key={l.href} href={l.href} className="text-sm font-medium text-muted-foreground hover:text-primary transition-smooth">{l.label}</a>)}
        </nav>
        <div className="flex items-center gap-2">
          <Button asChild size="sm" className="hidden sm:inline-flex bg-gradient-primary">
            <a href={`tel:${content.shop_phone}`}><Phone className="mr-1.5 h-4 w-4" /> Call</a>
          </Button>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2" aria-label="Menu">
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-border bg-background lg:hidden">
          <div className="container flex flex-col py-3">
            {links.map((l) => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-2 text-sm font-medium">{l.label}</a>)}
            <a href={`tel:${content.shop_phone}`} className="py-2 text-sm font-semibold text-accent">Call {content.shop_phone}</a>
          </div>
        </nav>
      )}
    </header>
  );
}
